import { InfoGridFuelCategory } from '@ahd/shared/types/ahd-fleet-api/fleet-car/enums';
import { FdTypes } from '@ahd/shared/types/ahd-fleet-api/fleet-car/fd/types';

import { Modules } from '../modules/_definition/types';
import { type Translations } from './translations';

const deDE: Translations = {
    buttons: {
        acceptMaps: 'Klicken Sie hier um der Nutzung von Google Maps zuzustimmen!',
        advancedSearch: 'Erweiterte Suche',
        back: 'Zurück',
        backToSearch: 'Zurück zur Suche',
        chooseVehicleHeading: 'Fahrzeug auswählen',
        clear: 'Leeren',
        close: 'Schließen',
        collapse: 'Zuklappen',
        continue: 'Weiter',
        expand: 'Ausklappen',
        filters: 'Filter',
        loadingView: 'Ansicht wird geladen...',
        loadMoreResults: 'Weitere Ergebnisse werden geladen...',
        loadMoreVehicles: 'Neue Fahrzeuge werden geladen...',
        loadMoreVehiclesVariant: 'Weitere Fahrzeuge anzeigen',
        nextPage: 'Nächste',
        no: 'Nein',
        prevPage: 'Vorherige',
        rateCalculator: 'Ratenrechner',
        resetData: 'Daten zurücksetzen',
        resetFilter: 'Filter zurücksetzen',
        search: 'Suchen',
        showAllLocations: 'Alle Standorte anzeigen',
        showAllVehicles: 'Alle {0} Fahrzeuge anzeigen',
        skip: 'Überspringen',
        vehicle: 'Fahrzeug',
        vehicles: 'Fahrzeuge',
        yes: 'Ja',
    },
    car: {
        ez: 'Erstzulassung',
        km: 'Laufleistung',
        ident: 'Auftragsnummer',
        kategorie: 'Kategorie',
        leergewicht: 'Leergewicht',
        typ: 'Fahrzeugtyp',
        types: {
            singular: {
                '-': '(unbekannt)',
                '1': 'Neuwagen',
                '2': 'Gebrauchtwagen',
                '4': 'Vorführwagen',
                '8': 'Mietwagen',
                '16': 'Sonderwagen',
                '32': 'Tageszulassung',
            },
            plural: {
                '-': '',
                '1': 'Neuwagen',
                '2': 'Gebrauchtwagen',
                '4': 'Vorführwagen',
                '8': 'Mietwagen',
                '16': 'Sonderwagen',
                '32': 'Tageszulassungen',
            },
        },
        sitze: 'Sitze',
        tueren: 'Türen',
        engine: {
            effizienz: 'Effizienz',
            hubraum: 'Hubraum',
            leistung: 'Leistung',
            motor: 'Motor',
            verbrauch: {
                '0': 'Verbrauch komb.',
                '1': 'CO₂-Emission',
                '2ndDrive': '2. Antrieb',
                combined: 'Kombiniert',
                effizienz: 'Effizienz',
                schadstoff: 'Euro-Norm',
                heading: 'Verbrauch und Emission',
                inner: 'Innerorts',
                outer: 'Außerorts',
                slow: 'Stadt',
                medium: 'Stadtrand',
                fast: 'Landstraße',
                veryFast: 'Autobahn',
                range: 'Reichweite',
                city: 'Stadt',
                protocol: 'Verbrauchsangaben',
                protocolBy: 'Verbrauchsangaben nach {0}',
                nefz: 'NEFZ',
                wltp: 'WLTP',
                noNEFZAvailable: 'NEFZ-Werte nicht verfügbar',
            },
        },
        garantie: 'Garantie',
        getriebe: 'Getriebe',
        siegel: 'Siegel',
        standort: 'Standort',
        farbe: 'Farbe',
        antrieb: 'Antrieb',
        verfuegbarkeit: 'Verfügbarkeit',
        aktion: 'Aktion',
        verfuegbarAb: 'Verfügbar ab',
        nowAvailable: 'sofort verfügbar',
        lieferzeit: 'Lieferzeit',
        isOrderCar: 'Bestellfahrzeug',
        onlyCommercial: 'Nur Gewerbe',
        preis: {
            inclMwst: 'inkl. {0} MwSt.',
            exclMwst: 'MwSt. nicht ausweisbar',
        },
        aus: {
            categories: {
                kopf: '',
                highlights: 'Highlights',
                technik: 'Technik und Sicherheit',
                multimedia: 'Multimedia',
                assistenz: 'Assistenzsysteme',
                innen: 'Innenausstattung',
                sitze: 'Sitze und Polster',
                aussen: 'Außenausstattung',
                scheinwerfer: 'Scheinwerfer und Leuchten',
                raeder: 'Räder und Reifen',
                pakete: 'Pakete',
                sonstiges: 'Sonstiges',
                fussnoten: 'Fußnoten',
                fuss: '',
            },
            assistenz: {
                title: 'Assistenzsysteme',
                25: 'Tempomat (GRA)',
                26: 'Einparkhilfe (APS)',
                48: 'Parklenkassistent',
                332: 'Abstandstempomat',
                402: 'Rückfahrkamera',
                514: 'Spurwechselassistent',
                515: 'Spurhalteassistent',
                1145: 'Verkehrszeichen-Erkennung',
            },
            aussen: {
                title: 'Außenausstattung',
                34: 'Schiebedach',
                41: 'Xenon-Licht',
                71: 'Leichtmetallfelgen',
                88: 'Anhängerkupplung',
                238: 'Panorama- / Glasdach',
                1140: 'LED-Scheinwerfer',
            },
            innen: {
                title: 'Innenausstattung',
                22: 'Klimaautomatik',
                23: 'Standheizung',
                24: 'Navigationssystem',
                27: 'elektrische Fensterheber',
                29: 'Sitzheizung',
                36: 'elektrische Sitze',
                81: 'Lederausstattung',
                278: 'Sportsitze',
                1119: 'Bluetooth',
            },
            showMore: {
                btn: 'Alle Ausstattungen anzeigen',
                subtitle: 'Es gibt noch mehr zu entdecken!',
            },
            sonstiges: {
                title: 'Sonstiges',
                61: 'Allradantrieb',
            },
        },
    },
    carSearch: {
        foundCar: 'Fahrzeug gefunden',
        foundCars: 'Fahrzeuge gefunden',
        forFilters: 'für Filter',
        grid: 'Raster',
        heading: 'Neu- und Gebrauchtwagen',
        heading2: 'Gebrauchtwagen',
        list: 'Liste',
        page: 'Seite',
        sort: 'Sortierung',
        view: 'Ansicht',
    },
    carTile: {
        priceGrid: {
            diff25a: '§ 25a (UStG)',
            diff25aDesc: 'MwSt. nicht ausweisbar',
        },
        verbrauchText: {
            combined: 'komb.',
            discharged: 'entladen',
            weighted: 'gew.',
        },
    },
    carView: {
        accessoires: {
            contactPlusAccessoiresPrice: '(+ Zubehör)',
            special: 'Sonderausstattung',
            standard: 'Serienausstattung',
            title: 'Hier finden Sie Zubehör für Ihren {0} {1}',
            titleSelected: 'Ihr ausgewähltes Zubehör',
            withAccessoiresPrice: 'zzgl. {0} € Zubehör',
        },
        contactTab: {
            approach: 'Anfahrt',
            call: 'Anrufen',
            mail: 'E-Mail',
            message: 'Anfrage',
            phone: 'Telefon',
        },
        contact: {
            abort: 'Abbrechen',
            bdkAddInsurances: 'Zusatzver|sicherung',
            bdkCreditCheck: 'Vorabein|schätzung',
            bdkSubmit: 'Anfrage abschicken',
            bdkVendorContact: '(Händler Anfrage)',
            title: 'Kontakt',
            contactPerson: 'Ihr Ansprechpartner',
            copyTel: {
                error: 'Fehler',
                success: 'Kopiert',
            },
            fd: 'Ihre Finanzdienstleistung',
            requestType: 'Anfrageart',
            requestTypes: {
                '0': 'Anfrage senden',
                '0a': 'Anfrage senden an',
                '0b': 'Finanzierungsanfrage stellen',
                '0c': 'Leasinganfrage stellen',
                '10': 'Termin anfragen',
                '10a': 'Termin anfragen bei',
                '12': 'Rückruf anfragen',
                '12a': 'Rückruf anfragen bei',
                '20': 'Probefahrt anfragen',
                '20a': 'Probefahrt anfragen bei',
                '27': 'Inzahlungnahme',
                '27a': 'Inzahlungnahme von',
                '0Short': 'Anfrage',
                '10Short': 'Termin',
                '12Short': 'Rückruf',
                '20Short': 'Probefahrt',
                '27Short': 'Inzahlungnahme',
            },
            name: 'Name',
            mail: 'E-Mail',
            priceAlert: 'Preiswecker',
            priceAlertInfo: 'Erhalten Sie eine E-Mail, wenn der Preis dieses Fahrzeugs unter Ihren Wunschpreis fällt',
            phone: 'Telefon',
            testDriveWithContactRequest: 'Probefahrt gewünscht',
            date: 'Wunschtermin',
            dateWithContactRequest: 'Wunschtermin Probefahrt',
            message: 'Ihre Anfrage',
            disclaimer: 'Ich habe die {0} gelesen',
            disclaimerLink: 'Datenschutzbestimmungen',
            reset: 'Von vorne beginnen',
            requestSuccess: 'Die Anfrage war erfolgreich',
            send: 'Anfrage senden',
            sending: 'Sende...',
            errorSending: 'Fehler beim Senden der Anfrage',
            errorSkipStep: 'Dieser Schritt kann nicht übersprungen werden',
            successSending: 'Anfrage erfolgreich gesendet',
            tryAgain: 'Bitte versuchen Sie es in einigen Minuten erneut',
            subjectPrefix: 'Fahrzeuganfrage für Fahrzeug {0}',
            subjectPrefixAbo: 'AutoAbo-Anfrage für Fahrzeug {0}',
            errors: {
                reCaptcha: 'ReCAPTCHA-Verifizierung fehlgeschlagen',
                requestType: 'Anfrageart fehlt',
                name: 'Name fehlt',
                mailMissing: 'E-Mail fehlt',
                mailInvalid: 'E-Mail in falschem Format',
                phone: 'Telefonnummer fehlt',
                date: 'Wunschtermin fehlt',
                message: 'Ihre Anfrage fehlt',
                acceptDisclaimer: 'Bitte Datenschutzbestimmung akzeptieren',
            },
        },
        newTabs: {
            0: {
                title: 'Ausstattung',
                url: 'ausstattung',
            },
            1: {
                title: 'Beschreibung',
                url: 'beschreibung',
            },
            2: {
                title: 'Verbrauchsangaben',
                url: 'verbrauchsangaben',
            },
            3: {
                title: 'Standort',
                url: 'standort',
            },
        },
        calculator: {
            bonitat: 'Bonität vorausgesetzt',
            businessFinancingRequest: 'gewerbliche Anfrage',
            button: 'Jetzt anfragen für {0} / Monat',
            buttonBDK: 'Direkt bei der BDK anfragen für {0} / Monat',
            buttonVendor: 'Direkt beim Händler anfragen für {0} / Monat',
            creditCheck: {
                companyAge: 'Alter der Firma (in Jahren)',
                insolvency: 'Gegen mich wurde ein Insolvenzverfahren oder eine Restschuldbefreiung durchgeführt:',
                isBusinessOwner: 'Ich habe ein Gewerbe angemeldet:',
                isBusinessVehicle: 'Ich möchte das Fahrzeug auch gewerblich nutzen:',
                monthlyExpenses: 'Gesamte monatliche Ausgaben:',
                monthlyIncome: 'Gesamtes monatliches Nettoeinkommen:',
                negativeSchufa: 'Ich habe negative SCHUFA-Einträge und ich leiste Zahlungen an Inkasso-Unternehmen:',
                peopleInHousehold: 'Personen im Haushalt:',
                title: 'Vorabeinschätzung zur Kreditvergabe',
                titleInfo: '(keine Schufa Anfrage, freiwillig)',
            },
            fd: {
                [FdTypes.ABO]: {
                    available: 'Verfügbar',
                    bank: 'Mobilitätspartner',
                    damageParticipation: 'Selbstbeteiligung',
                    deliveryOption: 'Lieferoptionen',
                    deliveryOption_faaren_delivery: 'Lieferung durch Faaren',
                    deliveryOption_no_delivery: 'Keine Lieferung',
                    deliveryOption_partner_delivery: 'Lieferung durch Anbieter',
                    deliveryTime: 'Lieferzeit nach Bestellung',
                    detail0: 'Alles inklusive bis auf Sprit',
                    detail1: 'Nach Ende der Mindestlaufzeit monatlich kündbar',
                    downPayment: 'Anzahlung',
                    duration: 'Laufzeit',
                    extraMileageCosts: 'Mehrkilometer',
                    fixedDuration: 'monatlich wechselbar',
                    immediatelyAvailable: 'Sofort verfügbar',
                    mileage: 'Monatliche Laufleistung',
                    minimumAge: 'Mindestalter',
                    minLicenseDuration: 'Mindestbesitzdauer Führerschein',
                    monthlyRateGross: 'Monatliche Rate brutto',
                    monthlyRateNet: 'Monatliche Rate netto',
                    pickUpOption: 'Abholoptionen',
                    pickUpOption_faaren_delivery: 'Abholung bei Faaren',
                    pickUpOption_no_delivery: 'Keine Abholung',
                    pickUpOption_partner_delivery: 'Abholung bei Anbieter',
                    provider: 'Provider',
                    title: 'Auto-Abo',
                    totalGross: 'Gesamtbetrag brutto',
                    totalNet: 'Gesamtbetrag netto',
                    type: 'Art',
                    vehiclePrice: 'Fahrzeugneupreis',
                    verb: 'mieten',
                },
                [FdTypes.BUSINESS_LEASING]: {
                    annualPercentageRate: 'Effektiver Jahreszins',
                    available: 'Verfügbar',
                    bank: 'Anbieterbank',
                    destinationChargesGross: 'Bereitstellungskosten brutto',
                    destinationChargesNet: 'Bereitstellungskosten netto',
                    detail0: 'Feste monatliche Rate',
                    detail1: 'Rückgabe des Fahrzeugs am Ende der Laufzeit',
                    downPayment: 'Sonderzahlung',
                    duration: 'Laufzeit',
                    extraMileageCosts: 'Mehrkilometer',
                    gapInsurance: 'GAP-Deckung',
                    gapInsuranceAmount: 'Betrag GAP-Deckung',
                    lowMileageCompensation: 'Minderkilometer',
                    mileage: 'Jährliche Laufleistung',
                    monthlyRateGross: 'Monatliche Rate brutto',
                    monthlyRateNet: 'Monatliche Rate netto',
                    nominalInterestRate: 'Sollzins p.a.',
                    provider: 'Provider',
                    registrationFeesGross: 'Zulassungskosten brutto',
                    registrationFeesNet: 'Zulassungskosten netto',
                    shortTitle: 'geschäftlich',
                    title: 'Geschäftsleasing',
                    totalGross: 'Gesamtbetrag brutto',
                    totalNet: 'Gesamtbetrag netto',
                    type: 'Art',
                    vehiclePrice: 'Fahrzeugpreis',
                    verb: 'leasen',
                },
                [FdTypes.FINANCING_AUTOCREDIT]: {
                    annualPercentageRate: 'Effektiver Jahreszins',
                    available: 'Verfügbar',
                    bank: 'Anbieterbank',
                    closingCosts: 'Abschlussgebühr',
                    destinationChargesGross: 'Bereitstellungskosten brutto',
                    destinationChargesNet: 'Bereitstellungskosten netto',
                    detail0: 'Geringe monatliche Rate',
                    detail1: 'Schlussrate mit mehreren Abschlussoptionen',
                    downPayment: 'Anzahlung',
                    duration: 'Laufzeit',
                    finalInstallment: 'Schlussrate',
                    gapInsurance: 'GAP-Deckung',
                    gapInsuranceAmount: 'Betrag GAP-Deckung',
                    gapInsurance_GAP: 'GAP',
                    gapInsurance_GAP_desc: 'GAP Absicherung gewünscht.',
                    gapInsurance_GAP_PLUS: 'GAP Plus',
                    gapInsurance_GAP_PLUS_desc: 'GAP Plus Absicherung gewünscht.',
                    gapInsurance_NONE: 'Nein',
                    gapInsurance_NONE_desc: 'Keine Absicherung gewünscht.',
                    mileage: 'Jährliche Laufleistung',
                    monthlyRateGross: 'Monatliche Rate brutto',
                    monthlyRateNet: 'Monatliche Rate netto',
                    nominalInterestRate: 'Sollzins p.a.',
                    paymentProtectionInsurance: 'Kreditschutzbrief',
                    paymentProtectionInsurance_NONE: 'Nein',
                    paymentProtectionInsurance_RSV: 'KSB',
                    paymentProtectionInsurance_RSVPLUS: 'KSB Plus',
                    paymentProtectionInsuranceAmount: 'Betrag Kreditschutzbrief',
                    provider: 'Provider',
                    registrationFeesGross: 'Zulassungskosten brutto',
                    registrationFeesNet: 'Zulassungskosten netto',
                    title: 'Finanzierung',
                    totalGross: 'Gesamtbetrag brutto',
                    totalNet: 'Gesamtbetrag netto',
                    typeOfNominalInterestRate: 'Art Sollzins',
                    type: 'Art',
                    vehiclePrice: 'Fahrzeugpreis',
                    verb: 'finanzieren',
                },
                [FdTypes.FINANCING_CLASSICCREDIT]: {
                    annualPercentageRate: 'Effektiver Jahreszins',
                    available: 'Verfügbar',
                    bank: 'Anbieterbank',
                    closingCosts: 'Abschlussgebühr',
                    destinationChargesGross: 'Bereitstellungskosten brutto',
                    destinationChargesNet: 'Bereitstellungskosten netto',
                    detail0: 'Geringe monatliche Rate',
                    detail1: 'Schlussrate mit mehreren Abschlussoptionen',
                    downPayment: 'Anzahlung',
                    duration: 'Laufzeit',
                    finalInstallment: 'Schlussrate',
                    gapInsurance: 'GAP-Deckung',
                    gapInsuranceAmount: 'Betrag GAP-Deckung',
                    gapInsurance_GAP: 'GAP',
                    gapInsurance_GAP_desc: 'GAP Absicherung gewünscht.',
                    gapInsurance_GAP_PLUS: 'GAP Plus',
                    gapInsurance_GAP_PLUS_desc: 'GAP Plus Absicherung gewünscht.',
                    gapInsurance_NONE: 'Nein',
                    gapInsurance_NONE_desc: 'Keine Absicherung gewünscht.',
                    mileage: 'Jährliche Laufleistung',
                    monthlyRateGross: 'Monatliche Rate brutto',
                    monthlyRateNet: 'Monatliche Rate netto',
                    nominalInterestRate: 'Sollzins p.a.',
                    paymentProtectionInsurance: 'Kreditschutzbrief',
                    paymentProtectionInsurance_NONE: 'Nein',
                    paymentProtectionInsurance_RSV: 'KSB',
                    paymentProtectionInsurance_RSVPLUS: 'KSB Plus',
                    paymentProtectionInsuranceAmount: 'Betrag Kreditschutzbrief',
                    provider: 'Provider',
                    registrationFeesGross: 'Zulassungskosten brutto',
                    registrationFeesNet: 'Zulassungskosten netto',
                    title: 'Finanzierung',
                    totalGross: 'Gesamtbetrag brutto',
                    totalNet: 'Gesamtbetrag netto',
                    typeOfNominalInterestRate: 'Art Sollzins',
                    type: 'Art',
                    vehiclePrice: 'Fahrzeugpreis',
                    verb: 'finanzieren',
                },
                [FdTypes.FINANCING_INDIVIDUAL]: {
                    annualPercentageRate: 'Effektiver Jahreszins',
                    available: 'Verfügbar',
                    bank: 'Anbieterbank',
                    closingCosts: 'Abschlussgebühr',
                    destinationChargesGross: 'Bereitstellungskosten brutto',
                    destinationChargesNet: 'Bereitstellungskosten netto',
                    detail0: 'Geringe monatliche Rate',
                    detail1: 'Schlussrate mit mehreren Abschlussoptionen',
                    downPayment: 'Anzahlung',
                    duration: 'Laufzeit',
                    finalInstallment: 'Schlussrate',
                    gapInsurance: 'GAP-Deckung',
                    gapInsuranceAmount: 'Betrag GAP-Deckung',
                    gapInsurance_GAP: 'GAP',
                    gapInsurance_GAP_desc: 'GAP Absicherung gewünscht.',
                    gapInsurance_GAP_PLUS: 'GAP Plus',
                    gapInsurance_GAP_PLUS_desc: 'GAP Plus Absicherung gewünscht.',
                    gapInsurance_NONE: 'Nein',
                    gapInsurance_NONE_desc: 'Keine Absicherung gewünscht.',
                    mileage: 'Jährliche Laufleistung',
                    monthlyRateGross: 'Monatliche Rate brutto',
                    monthlyRateNet: 'Monatliche Rate netto',
                    nominalInterestRate: 'Sollzins p.a.',
                    paymentProtectionInsurance: 'Kreditschutzbrief',
                    paymentProtectionInsurance_NONE: 'Nein',
                    paymentProtectionInsurance_RSV: 'KSB',
                    paymentProtectionInsurance_RSVPLUS: 'KSB Plus',
                    paymentProtectionInsuranceAmount: 'Betrag Kreditschutzbrief',
                    provider: 'Provider',
                    registrationFeesGross: 'Zulassungskosten brutto',
                    registrationFeesNet: 'Zulassungskosten netto',
                    title: 'Finanzierung',
                    totalGross: 'Gesamtbetrag brutto',
                    totalNet: 'Gesamtbetrag netto',
                    typeOfNominalInterestRate: 'Art Sollzins',
                    type: 'Art',
                    vehiclePrice: 'Fahrzeugpreis',
                    verb: 'finanzieren',
                },
                [FdTypes.FINANCING_VARIO]: {
                    annualPercentageRate: 'Effektiver Jahreszins',
                    available: 'Verfügbar',
                    bank: 'Anbieterbank',
                    closingCosts: 'Abschlussgebühr',
                    destinationChargesGross: 'Bereitstellungskosten brutto',
                    destinationChargesNet: 'Bereitstellungskosten netto',
                    detail0: 'Geringe monatliche Rate',
                    detail1: 'Schlussrate mit mehreren Abschlussoptionen',
                    downPayment: 'Anzahlung',
                    duration: 'Laufzeit',
                    finalInstallment: 'Schlussrate',
                    gapInsurance: 'GAP-Deckung',
                    gapInsuranceAmount: 'Betrag GAP-Deckung',
                    gapInsurance_GAP: 'GAP',
                    gapInsurance_GAP_desc: 'GAP Absicherung gewünscht.',
                    gapInsurance_GAP_PLUS: 'GAP Plus',
                    gapInsurance_GAP_PLUS_desc: 'GAP Plus Absicherung gewünscht.',
                    gapInsurance_NONE: 'Nein',
                    gapInsurance_NONE_desc: 'Keine Absicherung gewünscht.',
                    mileage: 'Jährliche Laufleistung',
                    monthlyRateGross: 'Monatliche Rate brutto',
                    monthlyRateNet: 'Monatliche Rate netto',
                    nominalInterestRate: 'Sollzins p.a.',
                    paymentProtectionInsurance: 'Kreditschutzbrief',
                    paymentProtectionInsurance_NONE: 'Nein',
                    paymentProtectionInsurance_RSV: 'KSB',
                    paymentProtectionInsurance_RSVPLUS: 'KSB Plus',
                    paymentProtectionInsuranceAmount: 'Betrag Kreditschutzbrief',
                    provider: 'Provider',
                    registrationFeesGross: 'Zulassungskosten brutto',
                    registrationFeesNet: 'Zulassungskosten netto',
                    title: 'Finanzierung',
                    totalGross: 'Gesamtbetrag brutto',
                    totalNet: 'Gesamtbetrag netto',
                    typeOfNominalInterestRate: 'Art Sollzins',
                    type: 'Art',
                    vehiclePrice: 'Fahrzeugpreis',
                    verb: 'finanzieren',
                },
                [FdTypes.PRIVATE_LEASING]: {
                    annualPercentageRate: 'Effektiver Jahreszins',
                    available: 'Verfügbar',
                    bank: 'Anbieterbank',
                    destinationChargesGross: 'Bereitstellungskosten brutto',
                    destinationChargesNet: 'Bereitstellungskosten netto',
                    downPayment: 'Sonderzahlung',
                    detail0: 'Feste monatliche Rate',
                    detail1: 'Rückgabe des Fahrzeugs am Ende der Laufzeit',
                    duration: 'Laufzeit',
                    extraMileageCosts: 'Mehrkilometer',
                    gapInsurance: 'GAP-Deckung',
                    gapInsuranceAmount: 'Betrag GAP-Deckung',
                    lowMileageCompensation: 'Minderkilometer',
                    mileage: 'Jährliche Laufleistung',
                    monthlyRateGross: 'Monatliche Rate brutto',
                    monthlyRateNet: 'Monatliche Rate netto',
                    nominalInterestRate: 'Sollzins p.a.',
                    provider: 'Provider',
                    registrationFeesGross: 'Zulassungskosten brutto',
                    registrationFeesNet: 'Zulassungskosten netto',
                    shortTitle: 'privat',
                    title: 'Privatleasing',
                    totalGross: 'Gesamtbetrag brutto',
                    totalNet: 'Gesamtbetrag netto',
                    type: 'Art',
                    vehiclePrice: 'Fahrzeugpreis',
                    verb: 'leasen',
                },
            },
            gapInsuranceStepperTitle: 'Zusatzversicherung hinzufügen',
            insuranceInfoText: '* Zusatzversicherungen wie ein Kreditschutzbrief (KSB){0}können auf Wunsch mit dem Händler vereinbart werden.',
            orderRequest: {
                orderBdkDescription: 'Stellen Sie Ihre Anfrage direkt an die Bank Deutsches Kraftfahrzeuggewerbe.',
                orderBdkInfo: '(Nur bei Finanzierungsanfragen mit erfolgreicher Vorabeinschätzung zur Kreditvergabe möglich)',
                orderBdkNotAvailable: 'Dieser Service steht im Moment leider nicht zur Verfügung.',
                orderVendorDescription: 'Stellen Sie Ihre Anfrage direkt an den Händler.',
            },
            title: {
                block: 'Einfach und flexibel finanzieren oder leasen',
                blockWithAbo: 'Einfach und flexibel finanzieren, leasen oder abonnieren',
                financing: 'Finanzierung',
                leasing: 'Leasing',
                rateSettings: 'Deine Rateneinstellungen',
                summary: {
                    financing: 'Dein Finanzierungsangebot',
                    leasing: 'Dein Leasingangebot',
                    autoAbo: 'Dein Auto-Abo Angebot',
                },
                typeChooser: 'Wähle dein Gift',
            },
        },
        downloadExposee: 'Herunterladen',
        exposeeError: 'Bei der Generierung ist ein Fehler aufgetreten!\nBitte versuchen Sie es später erneut',
        exposeeLoading: 'Einen Moment bitte, das Exposé wird generiert',
        exposeeReady: 'Das Exposé steht nun zum Download bereit',
        locationUsers: 'Ihre Ansprechpartner',
        locationUsersContact: 'Kontakt aufnehmen',
        share: {
            copy: 'Link kopieren',
            mail: 'E-Mail',
            title: 'Teilen',
        },
        showExposee: 'Exposé',
        similarCars: 'Ähnliche Fahrzeuge',
        tabs: {
            0: 'Fahrzeugdaten',
            1: 'Beschreibung',
            2: 'Standort',
        },
        tradeIn: {
            heading: 'Inzahlungnahme?',
            content: 'Sie möchten Ihr aktuelles Fahrzeug in Zahlung geben und schnell einen unverbindlichen Marktwert erfahren?',
            button: 'Jetzt berechnen',
        },
        verbrauch: {
            combined: 'Kombiniert',
            combinedWeighted: 'Kombiniert (gewichtet)',
            combinedWeightedShort: 'Komb. gew.',
            co2class: 'CO₂-Klasse',
            co2classWeighted: 'CO₂-Klasse (gewichtet)',
            co2costs: 'Mögliche CO₂-Kosten über die nächsten 10 Jahre (bei 15.000 km / Jahr):',
            co2costsBaseLow: 'bei angenommenen niedrigen ⌀ CO₂-Preis von {0}',
            co2costsBaseMedium: 'bei angenommenen mittleren ⌀ CO₂-Preis von {0}',
            co2costsBaseHigh: 'bei angenommenen hohen ⌀ CO₂-Preis von {0}',
            co2costsLow: 'niedriger CO₂-Preis',
            co2costsMedium: 'mittlerer CO₂-Preis',
            co2costsHigh: 'hoher CO₂-Preis',
            discharged: 'bei entladener\nBatterie',
            energycosts: 'Energiekosten pro Jahr (bei 15.000 km / Jahr)',
            emission: 'Emissionen',
            emissionWeighted: 'Emissionen (gewichtet)',
            emissionWeightedShort: 'Emiss. gew.',
            euronorm: 'Euro-Norm',
            extraHigh: 'Autobahn',
            fuelCostsYear: {
                [InfoGridFuelCategory.BIFUEL]: 'Jahresdurchschnitt Kraftstoffpreis',
                [InfoGridFuelCategory.CELL]: 'Jahresdurchschnitt Wasserstoffpreis',
                [InfoGridFuelCategory.DEFAULT]: 'Jahresdurchschnitt Kraftstoffpreis',
                [InfoGridFuelCategory.ELECTRO]: 'Jahresdurchschnitt Strompreis',
                [InfoGridFuelCategory.GAS]: 'Jahresdurchschnitt Kraftstoffpreis',
                [InfoGridFuelCategory.OTHERHYBRID]: 'Jahresdurchschnitt Kraftstoffpreis',
                [InfoGridFuelCategory.PLUGINHYBRID]: 'Jahresdurchschnitt Kraftstoffpreis',
            },
            fuelCostsYearState: 'Preis: {0} | Stand: {1}',
            header: 'Kraftstoffverbrauch',
            headerDischarged: 'Kraftstoffverbrauch bei entladener Batterie',
            headerElectro: 'Stromverbrauch',
            headerPlugIn: 'Stromverbrauch bei rein elektrischem Betrieb',
            high: 'Landstraße',
            medium: 'Stadtrand',
            motor: 'Motor',
            low: 'Stadt',
            range: 'Elektrische Reichweite',
            title: 'Energieverbrauch und Emission',
            weighted: 'gewichtet',
        },
    },
    common: {
        and: 'und',
        at: 'bei',
        atThe: 'bei der',
        brutto: 'brutto',
        in: 'in',
        netto: 'netto',
        notAvailable: 'nicht verfügbar',
    },
    filter: {
        special: 'Aktionsfahrzeuge',
        aktion: 'Aktionsfahrzeuge',
        specialActive: 'Nur Aktionsfahrzeuge',
        exteriorColor: 'Farbe',
        make: 'Hersteller',
        hersteller0: 'Hersteller',
        model: 'Modell',
        modell0: 'Modell',
        condition: 'Fahrzeugtyp',
        akttypList: 'Fahrzeugtyp',
        stime: 'Standzeit',
        location: 'Standort',
        seller: 'Standort',
        Standort: 'Standort',
        locationMap: {
            buttonText: 'Kartenansicht',
            dialog: {
                filterButton: '{0} Fahrzeuge anzeigen',
                filterAllButton: 'Alle Fahrzeuge anzeigen',
                title: 'Fahrzeuge nach Standorten filtern',
                selectAll: 'Alle auswählen',
            },
        },
        category: 'Aufbau',
        aufbau: 'Aufbau',
        aufbauten: 'Aufbauten',
        usedCarSeal: 'Siegel',
        hasSeal: 'Siegel',
        price: 'Preis',
        priceFrom: 'Preis von',
        priceTo: 'Preis bis',
        rate: 'Monatliche Rate',
        rateFrom: 'Monatliche Rate von',
        rateTo: 'Monatliche Rate bis',
        firstRegistration: 'Erstzulassung',
        firstRegistrationFrom: 'Erstzulassung von',
        firstRegistrationTo: 'Erstzulassung bis',
        mileage: 'Laufleistung',
        mileageFrom: 'Laufleistung von',
        mileageTo: 'Laufleistung bis',
        ort: 'Standort',
        power: 'Leistung',
        powerFrom: 'Leistung von',
        powerTo: 'Leistung bis',
        fuel: 'Motor',
        motoren: 'Motor',
        gearbox: 'Getriebe',
        available: 'Sofort verfügbar',
        sofort: 'Sofort verfügbar',
        availableActive: 'Nur sofort verfügbar',
        tags: 'Aktion',
        tagsExclude: 'Aktionen ausschließen',
        fd: 'Finanzdienstleistungen',
        accessoirs: 'Ausstattung',
        accessoirsHeading: 'Ausstattungen auswählen',
        searchText: 'Volltextsuche',
        set: 'gesetzt',
        setFilter: 'Filter gesetzt',
        availabileDate: 'Verfügbarkeitsdatum',
        asc: 'aufsteigend',
        desc: 'absteigend',
        Alle: 'Alle',
        alle: 'alle',
        from: 'ab',
        to: 'bis',
        moreThan: 'mehr als',
        vehicleClass: 'Fahrzeugtyp',
        order: 'Reihenfolge',
        page: 'Seite',
        pageSize: 'Anzahl',
        sort: 'Sortierung',
        ignoreStandort: 'Standort ausschließen',
        locExclude: 'Standort ausschließen',
        locInclude: 'Standort',
        locSourceExclude: 'Standort (Quell-ID) ausschließen',
        locSourceInclude: 'Standort (Quell-ID)',
        nfzHersteller: 'Hersteller NFZ',
        nfz: 'NFZ',
        lang: 'Sprache',
        views: 'Standard',
        takeinAsc: 'Älteste zuerst',
        takeinDesc: 'Neueste zuerst',
    },
    footer: {
        co2DatLink: 'Leitfaden CO₂',
        pshButton: 'Produktsicherheitshinweise des Herstellers öffnen',
        textPsh:
            'Produktsicherheitsinformationen: Hersteller (((car.productSecurity.tradename))) | Anschrift: (((car.productSecurity.firm))), (((car.productSecurity.address))) | Telefon: (((car.productSecurity.phone))) | Mail: (((car.productSecurity.email)))',
        textWLTP:
            'Die Informationen erfolgen gemäß der Pkw-Energieverbrauchskennzeichnungsverordnung. Die angegebenen Werte wurden nach dem vorgeschrieben Messverfahren WLTP (World Harmonised Light Vehicles Test Procedure) ermittelt. Der Kraftstoffverbrauch und der C02-Ausstoß eines PKW sind nicht nur von der effizienten Ausnutzung des Kraftstoffs durch den PKW, sondern auch vom Fahrstil und anderen nichttechnischen Faktoren abhängig. C02 ist das für die Erderwärmung hauptsächlich verantwortliche Treibgas. Ein Leitfaden über den Kraftstoffverbrauch und die C02-Emissionen aller in Deutschland angebotenen neuen PKW-Modelle ist unentgeltlich in elektronischer Form einsehbar an jedem Verkaufsort in Deutschland, an dem neue Personenkraftfahrzeuge ausgestellt oder angeboten werden. Der Leitfaden ist auch abrufbar unter der Internetadresse: {0}. Es werden nur die C02-Emissionen angegeben, die durch den Betrieb des PKW entstehen. C02-Emissionen, die durch die Produktion und Bereitstellung des PKW sowie des Kraftstoffes bzw. der Energieträger entstehen oder vermieden werden, werden bei der Ermittlung der C02-Emissionen gemäß WLTP nicht berücksichtigt.',
    },
    menu: {
        activeConfig: 'Aktive Konfiguration',
        currentVersion: 'Aktuelle Version',
        dark: 'Dunkler Modus',
        disabled: 'Deaktiviert',
        heading: 'Hauptmenü',
        light: 'Heller Modus',
    },
    modules: {
        [Modules.Aktionsslider]: 'Aktionsslider',
        [Modules.ConfigListing]: 'Konfigurationen',
        [Modules.ErweiterteSchnellsuche]: 'Erweterte Schnellsuche',
        [Modules.Fahrzeugliste]: 'Fahrzeugliste',
        [Modules.Fahrzeugslider]: 'Fahrzeugslider',
        [Modules.Fahrzeugsuche]: 'Fahrzeugsuche',
        [Modules.Finanzierungsansicht]: 'Finanzierungsansicht',
        [Modules.Install]: 'Installationsdokumentation',
        [Modules.Menu]: 'Menü',
        [Modules.Print]: 'Exposé',
        [Modules.Schnellsuche]: 'Schnellsuche',
        [Modules.Standorte]: 'Standorte',
    },
    opening: {
        closed: 'geschlossen',
        openTill: 'offen bis {0} Uhr',
        openAtToday: 'geschlossen, öffnet um {0} Uhr',
        openAtTomorrow: 'geschlossen, öffnet morgen um {1} Uhr',
        openAtOtherDay: 'geschlossen, öffnet am {0} um {1} Uhr',
        verkauf: 'Verkauf',
        service: 'Service',
        werkstatt: 'Werkstatt',
    },
    time: {
        days: {
            '0': 'Sonntag',
            '1': 'Montag',
            '2': 'Dienstag',
            '3': 'Mittwoch',
            '4': 'Donnerstag',
            '5': 'Freitag',
            '6': 'Samstag',
            singular: 'Tag',
            plural: 'Tage',
        },
        month: {
            plural: 'Monate',
            singular: 'Monat',
        },
        week: {
            plural: 'Wochen',
            singular: 'Woche',
        },
        year: {
            plural: 'Jahre',
            singular: 'Jahr',
        },
    },
    validation: {
        invalid: 'Fehlerhaft!',
        invalidEntry: 'Fehlerhafter Wert! Erlaubt: {0}',
        maxCarPrice: 'Der Preis liegt über dem Fahrzeugpreis',
        minPrice: 'Preis zu niedrig',
        required: 'Pflichtfeld',
        wholeNumber: 'Nur Ganzzahlen erlaubt',
    },
};

export default deDE;
